export default [
    //投诉建议
    {
        path: '/complaints',
        name: 'complaints',
        component: () => import('../views/complaint/complaints.vue'),
        meta: {
            hasTabbar: true,
            title: '投诉建议'
        }
    },
    //留言板
    {
        path: '/messageBoard',
        name: 'messageBoard',
        component: () => import('../views/complaint/messageBoard.vue'),
        meta: {
            hasTabbar: true,
            title: '留言板'
        }
    },
];
